import { IItem } from '@rbi-ctg/menu';
import { ProductWizardStep } from 'state/product-wizard-v2/types';

import { ProductAddToCartCta } from '../product-add-to-cart-cta/product-add-to-cart-cta';

import { ProductComboCtaCustomization } from './product-combo-cta-customization';

interface IProductComboCta {
  currentStep: ProductWizardStep;
  modifierSelections: any; // to-do-for-later: Determine if this `any` can be replaced with UserSelectionModifierSlotMap
  selectedItem: IItem | undefined;
}
export const ProductComboCta = ({
  currentStep,
  modifierSelections,
  selectedItem,
}: IProductComboCta) => {
  switch (currentStep) {
    case ProductWizardStep.ProductCustomization:
      return (
        <ProductComboCtaCustomization
          selectedItem={selectedItem}
          modifierSelections={modifierSelections}
        />
      );
    case ProductWizardStep.ProductHome:
      return <ProductAddToCartCta modifierSelections={modifierSelections} />;
    default:
      return null;
  }
};
